export default [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: require('@app2/modules/Onboarding/Pages/Onboarding').default,
  },
];
